import { render, staticRenderFns } from "./DocMermaid.vue?vue&type=template&id=5270ac0e&"
import script from "./DocMermaid.vue?vue&type=script&lang=js&"
export * from "./DocMermaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports